import { writable } from "svelte/store"

/**
 * @typedef {Object} DocDetails - document details related to single publishing
 * @type {Object}
 *
 * @property {String} id - denotes the document id from initial api.
 * @property {String} url - proposed document Viewpage URL
 * @property {string} file - uploaded file
 */

/**
 * @type {import("svelte/store").Writable<DocDetails>}
 */

const DocDetails = writable({
  id: "",
  url: "",
  file: "",
})

export default DocDetails
